import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Gsp_pipes } from '../pipes';
import { PipesModule } from 'digital-core';

@NgModule({
    declarations: [
        ...Gsp_pipes
    ],
    imports: [CommonModule, PipesModule],
    exports: [
        PipesModule,
        ...Gsp_pipes
    ],
   
})
export class GspPipesModule { }